
<div class="dialog-header">
  <h6>{{ isEditMode ? 'Edit Client' : 'Add Client' }}</h6>
  <button mat-icon-button class="close-icon" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<form [formGroup]="clientForm" (ngSubmit)="onSubmit()" [ngClass]="{ 'dark-label': isDarkMode() }">
  <mat-form-field appearance="outline">
    <mat-label>Client Name</mat-label>
    <input matInput formControlName="company_name"
      (keypress)="disallowNumericData($event);allowLimitedInput($event, 50)" (paste)="onPaste($event)"
      (blur)="onInputTrim('company_name');" />
    <mat-error *ngIf="clientForm.get('company_name')?.hasError('required')">
      Client is required.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" class="example-chip-list" class="inputWidthForWindowFill">
    <mat-chip-grid #chipGrid>
      <mat-chip *ngFor="let email of emailList" [removable]="removable" (removed)="removeEmail(email)">
        {{ email }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
      <input placeholder="Add email, press enter or comma" [matChipInputFor]="chipGrid" class="inputTextArea"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addEmail($event)" >
    </mat-chip-grid>
  </mat-form-field>
  <div class="vessel-filter-section"> 
    <mat-form-field appearance="outline">
      <!-- <mat-label>Search vessels...</mat-label> -->
      <input matInput placeholder="Search vessels..." [(ngModel)]="vesselSearchText" [ngModelOptions]="{standalone: true}" (input)="filterVessels()"> 
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <div class="vessel-checkbox-list">
      <div class="vessel-checkbox-item select-all" *ngIf="filteredVessels.length > 0">
        <mat-checkbox [checked]="isAllSelected" [indeterminate]="isIndeterminate" (change)="toggleSelectAll()" color="primary">
          Select All
        </mat-checkbox>
      </div>
      <div class="vessel-checkbox-item" *ngFor="let vessel of filteredVessels">
        <mat-checkbox [(ngModel)]="vessel.selected" [ngModelOptions]="{standalone: true}" (change)="onVesselChange(vessel)" color="primary">
          {{ vessel.name }}
        </mat-checkbox>
      </div>
      <div *ngIf="filteredVessels.length === 0 && vesselList.length > 0" class="no-data">
        <p>No matching vessels found</p>
      </div>
      <div *ngIf="vesselList.length === 0" class="no-data">
        <p>No vessels available</p>
      </div>
    </div>
  </div>
  <mat-form-field appearance="outline"> 
    <mat-label>Client Address</mat-label>
    <textarea matInput rows="3" formControlName="address"></textarea>
  </mat-form-field>

  <div>
    <button mat-flat-button color="primary" class="add-country" type="submit"> {{ isEditMode ? 'Update Client' : 'Add Client' }}</button>
  </div>
</form>
